import { ref } from 'vue'
import { mergeDeep } from '@/common/js/utils.js'
import { MEDIAS } from '@/common/js/constants.js'
import { getAccountById } from '@/api/ptom.data.model.js'
import { addTargeting, updateTargeting, getTargetingDataById } from '@/api/manage.model'
import { getInitForm } from '@/views/promote/targeting/components/gdtv3/useGdtv3TargetingForm.js'
import { Message } from 'view-design'
import { setLocal } from '@/common/js/api.js'

// 编辑、复制记录类型  edit | copy
const editType = ref('')

/**
 * @description: 编辑定向，更新提交
 */
export function useTargetingFormEdit(targetingFormRef) {
  const initFormEdit = async (id, edittype) => {
    editType.value = edittype
    try {
      const data = await getTargetingDataById({ targetingId: id })
      const { targetingParamJson, accountIds, targetingName, targetingDesc } = data
      const accountInfo = await getAccountById({ ad_account_id: Number(accountIds) })

      const targetingForm = {
        // 添加初始化定向表单参数
        // ...getInitForm(accountInfo),
        // ...targetingParamJson,

        ...mergeDeep(getInitForm(accountInfo), targetingParamJson),
        targetingId: id,
        account: {
          name: accountInfo.adAccount,
          id: accountInfo.id
        },
        name: targetingName,
        description: targetingDesc
      }

      targetingFormRef.value.setForm(targetingForm)
      return Promise.resolve()
    } catch (e) {
      console.log('eeeeeee output: ', e)
      return Promise.reject(new Error('获取定向信息失败'))
    }
  }

  return {
    initFormEdit
  }
}

/**
 * @description: 提交定向包
 */
export function useTargetingFormSubmit(router, getInitForm) {
  const submitLoading = ref(false)
  const targetingFormRef = ref(null)

  const formValidator = async (done) => {
    try {
      await targetingFormRef.value.validate()
      done && done()
      return Promise.resolve()
    } catch (e) {
      console.log('eeeeeeee output: ', e)
      return Promise.reject(new Error('targetingFormRef validate error'))
    }
  }

  const onFormSubmit = async () => {
    if (submitLoading.value) return
    try {
      await formValidator()
      const targetingForm = targetingFormRef.value.getForm()
      const { account, name, description, targetingId, ...restTargetingParams } = targetingForm

      if (account?.id) {
        // 保存账号选择到本地缓存，下次新建定向回显
        setLocal('gdtTargetingFormAccount', account)
      }
      const params = {
        mediaId: MEDIAS.GDT,
        accountIds: account.id,
        targetingName: name,
        targetingDesc: description,
        targetingParam: JSON.stringify(restTargetingParams)
      }
      submitLoading.value = true
      ; (targetingId && editType.value === 'edit' ? updateTargeting({ targetingId, ...params }) : addTargeting(params))
        .then((data) => {
          if (router) {
            if (data) {
              Message.success({
                closable: true,
                duration: 2,
                content: '提交成功！2秒后自动跳转'
              })
              setTimeout(onFormCancel, 2000)
            }
          } else {
            onFormCancel()
          }

          return Promise.resolve()
        })
        .catch(() => {
          submitLoading.value = false
          return Promise.reject(new Error())
        })
    } catch (e) {
      console.log(' targeting submit error output: ', e)
    }
  }

  const onFormCancel = () => {
    submitLoading.value = false
    editType.value = ''

    if (getInitForm) {
      targetingFormRef.value.setForm(getInitForm())
    }
    router && router.replace({ name: 'targetingslist' })
  }
  return {
    targetingFormRef,
    submitLoading,
    formValidator,
    onFormSubmit,
    onFormCancel
  }
}
